import { TenantSettingsIntegrationsSaferpayDto } from './tenant-settings-integrations-saferpay.dto';

export class TenantSettingsPaymentProvidersDto {
  isEnabled?: boolean | null;
  apiPaymentBaseUrl?: string | null;
  saferpay?: TenantSettingsIntegrationsSaferpayDto | null;
}
